var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21297_15609)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9255 2.53426H10.3838V1.45093H9.30046V2.53426H4.96712V1.45093H3.88379V2.53426H3.34212C2.74087 2.53426 2.26421 3.02176 2.26421 3.61759L2.25879 11.2009C2.25879 11.7968 2.74087 12.2843 3.34212 12.2843H10.9255C11.5213 12.2843 12.0088 11.7968 12.0088 11.2009V3.61759C12.0088 3.02176 11.5213 2.53426 10.9255 2.53426ZM10.9255 11.2009H3.34212V5.24259H10.9255V11.2009ZM4.42546 6.32593H7.13379V9.03426H4.42546V6.32593Z",
    fill: "#323232"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21297_15609"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(0.633789 0.90918)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.1c0e9dd885c3727d6a5e2fb6f000adde.svg";
export { ForwardRef as ReactComponent };